module.exports = __webpack_public_path__ + "static/users_form-074828597b683a4896bb1fb669f59ac0.png";